import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "external",
  "use": "external-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"external\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.0001 4H15.0001L16.793 5.79289L9.29297 13.2929L10.7072 14.7071L18.2072 7.20711L20.0001 9V4Z\" fill=\"currentColor\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 6H6V18H18V12H20V18V20H18H6H4V18V6V4H6H12V6Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol